import React, { useState,useEffect } from 'react';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
import '../../styles/components/usefulComponent.scss'
function SortingSelect({ data, setData,originalData,isGrouped,cardGridType }) {
  const [sortValue, setSortValue] = useState('');
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.SortingSelect[key][currentLang]; // Adjust the path according to your JSON structure
 const [isOpen, setIsOpen] = useState(false);




 const handleSort = (event) => {
  const value = event.target.value;
  setSortValue(value);

  if (!isGrouped) {
    let sortedData = [...data];

    switch (value) {
      case ' ':
        sortedData = [...originalData]; // Reset to originalData
        break;
      case 'priceAsc':

        sortedData.sort((a, b) =>
          cardGridType === 'CardGridSell'
        ? a.Price - b.Price
        : a.EstimateValue - b.EstimateValue)
        break;
      case 'priceDesc':
     
      sortedData.sort((a, b) =>
        cardGridType === 'CardGridSell'
      ? b.Price - a.Price
      : b.EstimateValue - a.EstimateValue)
      break;
      case 'playerNameAsc':
        sortedData.sort((a, b) => a.Name.localeCompare(b.Name));
        break;
      case 'playerNameDesc':
        sortedData.sort((a, b) => b.Name.localeCompare(a.Name));
        break;
      case 'cardNameAsc':
        sortedData.sort((a, b) => a.cardName.localeCompare(b.cardName));
        break;
      case 'cardNameDesc':
        sortedData.sort((a, b) => b.cardName.localeCompare(a.cardName));
        break;
      case 'dateAddedAsc':
        sortedData.sort((a, b) =>
          cardGridType === 'CardGridSell'
            ? new Date(a.DateAdded).getTime() - new Date(b.DateAdded).getTime()
            : new Date(a.InsertDate).getTime() - new Date(b.InsertDate).getTime()
        );
        break;
      case 'dateAddedDesc':
        sortedData.sort((a, b) =>
          cardGridType === 'CardGridSell'
            ? new Date(b.DateAdded).getTime() - new Date(a.DateAdded).getTime()
            : new Date(b.InsertDate).getTime() - new Date(a.InsertDate).getTime()
        );
        break;
      default:
        sortedData = [...data];
    }

    // Map through the sortedData and log all DateAdded values
    sortedData.map((item) => {
      console.log(`DateAdded: ${item.DateAdded}`);
    });

    setData(sortedData); // Update state with sorted data

  } else {
    const dataArray = Array.from(data.entries());
    let sortedArray = [...dataArray]; // Copy of the entries for safe sorting

    switch (value) {
      case ' ':
        sortedArray = Array.from(originalData.entries()); // Reset
        break;
      case 'priceAsc':
        sortedArray.sort((a, b) => a[1].EstimateValue - b[1].EstimateValue);
        break;
      case 'priceDesc':
        sortedArray.sort((a, b) => b[1].EstimateValue - a[1].EstimateValue);
        break;
      case 'playerNameAsc':
        sortedArray.sort((a, b) => a[1].Name.localeCompare(b[1].Name));
        break;
      case 'playerNameDesc':
        sortedArray.sort((a, b) => b[1].Name.localeCompare(a[1].Name));
        break;
      case 'cardNameAsc':
        sortedArray.sort((a, b) => a[1].cardName.localeCompare(b[1].cardName));
        break;
      case 'cardNameDesc':
        sortedArray.sort((a, b) => b[1].cardName.localeCompare(a[1].cardName));
        break;
      case 'dateAddedAsc':
        sortedArray.sort((a, b) =>
          cardGridType === 'CardGridSell'
            ? new Date(a[1].DateAdded).getTime() - new Date(b[1].DateAdded).getTime()
            : new Date(a[1].InsertDate).getTime() - new Date(b[1].InsertDate).getTime()
        );
        break;
      case 'dateAddedDesc':
        sortedArray.sort((a, b) =>
          cardGridType === 'CardGridSell'
            ? new Date(b[1].DateAdded).getTime() - new Date(a[1].DateAdded).getTime()
            : new Date(b[1].InsertDate).getTime() - new Date(a[1].InsertDate).getTime()
        );
        break;
      default:
        sortedArray = [...dataArray];
    }



    const sortedMap = new Map(sortedArray);
    setData(sortedMap); // Update state with sorted map
  }
};



  return (
 // SortingSelect.jsx
<div className={`select-wrapper select-sorting ${isOpen ? "open" : ""}`}>
  <select
    value={sortValue}
    onChange={handleSort}
    onFocus={() => setIsOpen(true)}
    onBlur={() => setIsOpen(false)}
    className="custom-select-simple"
  >
    <option value=" ">{t("Order By")}</option>
    <option value="priceAsc">{t("Price/Value (Low to High)")}</option>
    <option value="priceDesc">{t("Price/Value (High to Low)")}</option>
    <option value="playerNameAsc">{t("Player Name (A-Z)")}</option>
    <option value="playerNameDesc">{t("Player Name (Z-A)")}</option>
    <option value="cardNameAsc">{t("Card Name (A-Z)")}</option>
    <option value="cardNameDesc">{t("Card Name (Z-A)")}</option>
    <option value="dateAddedDesc">{t("Date Added (Newest to Oldest)")}</option>
    <option value="dateAddedAsc">{t("Date Added (Oldest to Newest)")}</option>
  </select>
</div>

 
  );
}

export default SortingSelect;
